import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
// let _formateCartList = function(arr){
//   let newArr = []
//   if(!arr||(arr&&!arr.length==0)){
//     return null
//   }else{
//     arr.forEach((item,index)=>{
//     let haveThisStore = newArr.some((item2,index2)=>{
//        return item2[0].storeId ==item.storeId
//       })

//     if(haveThisStore){
//       newArr[index2].push(arr[index])
//     }else{
//       let arr3 = []
//       arr3.push(arr[index])
//       newArr.push(arr3)
//     }
//     })

//     return newArr
//   }
// }

Vue.use(Vuex)
const state = {
    adminInfo: {
        avatar: 'default.jpg'
    },
    userInfo: null,
    companyInfo: null,
    currentOrderRow: null,
    loginInfo: null,
    cartList: null,
    currentEditRow: null,
    currentEditIndex: '',
    vueXPageIndex: 0,
    vueXTypeIndex: 0,
    cureentPageSize: '',
    checkedCustomer: null,
    checkedGoods: null,
    isGoodsSearch: false,
    // searchInput: '',
}
const mutations = {
    loginOutClearInfo(state) {
        state.userInfo = null;
        state.companyInfo = null;
    },
    // searchInputChange(state, searchInfo) {
    //     state.searchInput = searchInfo;
    // },
    isFalse(state) {
        state.isGoodsSearch = false;
    },
    isTrue(state) {
        state.isGoodsSearch = true;
    },
    saveUserInfo(state, userInfo) {
        state.userInfo = userInfo;
    },
    saveCompanyInfo(state, companyInfo) {
        state.companyInfo = companyInfo;
    },
    savecurrentEditRow(state, currentEditRow) {
        state.currentEditRow = currentEditRow;
    },
    savecurrentIndex(state, currentEditIndex) {
        state.currentEditIndex = currentEditIndex;
    },
    saveCureentPageSize(state, cureentPageSize) {
        state.cureentPageSize = cureentPageSize;
    },

    saveVueXPageIndex(state, vueXPageIndex) {
        state.vueXPageIndex = vueXPageIndex;
    },
    saveVueXTypeIndex(state, vueXTypeIndex) {
        state.vueXTypeIndex = vueXTypeIndex;
    },
    saveCheckedCustomer(state, checkedCustomer) {
        state.checkedCustomer = checkedCustomer
    },
    saveCheckedGoods(state, checkedGoods) {
        state.checkedGoods = checkedGoods
    },
    // import city from "@/utils/city";
    // addrId: 110101;
    // address: "北京";
    // avgWeight: 0;
    // birthPlace: "110000";
    // birthType: 1;
    // breed: "仔猪,外三元仔猪,";
    // buyUnit: "箱";
    // coverPlan: "group1/M00/00/01/wKjKBFzaMWOEU8KyAAAAAMED9f8003.jpg";
    // empId: "10000010";
    // empName: "胡云飞";
    // goodsType: "白条";
    // grade: 2;
    // id: "309f39b1b575470ab1d438a48102b70e";
    // image: "group1/M00/00/07/wKjKBF1yWo2EIILFAAAAAHAYnOM417.jpg";
    // kind: 2;
    // minBuyCount: 10;
    // name: "三级分类测试";
    // orderPrice: 10;
    // payDays: 0;
    // price: 1;
    // remark: "书";
    // sale_number: 0;
    // spec: "一元已投";
    // status: 1;
    // stockCount: 118;
    // storeGrade: 1;
    // storeId: "4a686a2ba38e469488299de11121a046";
    // storeName: "小飞公司";
    // tags: null;
    // topNo: 0;
    // types: "050,080,";
    // unit: "头";
    // unitWeight: 10;
    // userId: "10000010";
    // weightValue: 0;




    //判断登录状态失败后存储当前页面信息，以供登录时返回
    setLoginInfo(state, data) {
        state.loginInfo = data
    },
    //购物车的操作


    // let arr=[[], [],[]]

    //1.添加新商品
    addCartList(state, data) {
        if (data.minBuyCount > data.stockCount) {
            alert('库存不足2')
            return
        }
        //data是商品信息
        console.log('添加新商品')
        let cartList = JSON.parse(JSON.stringify(state.cartList))
        if (cartList) {
            let currentIndex
            let haveThisStore = cartList.some((item, index) => {
                if (item[0].storeId == data.storeId) {
                    currentIndex = index
                }
                return item[0].storeId == data.storeId
            })
            if (haveThisStore) {
                //判断有没有这个商品
                let currentGoodsIndex
                let haveThisGoods = cartList[currentIndex].some((item2, index2) => {
                        if (item2.id == data.id) {
                            currentGoodsIndex = index2
                        }

                        return item2.id == data.id
                    })
                    //如果有
                if (haveThisGoods) {

                    console.log('cartList[currentIndex][currentGoodsIndex].cart_num')
                    console.log(cartList[currentIndex][currentGoodsIndex].cart_num)

                    console.log('cartList[currentIndex][currentGoodsIndex].stockCount')
                    console.log(cartList[currentIndex][currentGoodsIndex].stockCount)

                    if (data._buyNum) {
                        cartList[currentIndex][currentGoodsIndex].cart_num += data._buyNum
                    } else {
                        cartList[currentIndex][currentGoodsIndex].cart_num += 1
                    }
                    if (cartList[currentIndex][currentGoodsIndex].cart_num > cartList[currentIndex][currentGoodsIndex].stockCount) {
                        alert('库存不足666')
                        return
                    }
                    cartList[currentIndex][currentGoodsIndex].cart_checked = true
                } else {
                    //如果没有这个商品
                    let newItem = {
                        ...data
                    }
                    newItem.cart_checked = true

                    if (data._buyNum) {
                        newItem.cart_num = data._buyNum
                    } else {
                        newItem.cart_num = data.minBuyCount
                    }
                    cartList[currentIndex].unshift(newItem)
                }

            } else {
                //没有这个店铺

                let newItem = {
                    ...data
                }
                newItem.cart_checked = true
                if (data._buyNum) {
                    newItem.cart_num = data._buyNum
                } else {
                    newItem.cart_num = data.minBuyCount
                }
                cartList.unshift([{...newItem }])
            }
        } else {

            //购物车列表为空
            let newItem = {
                ...data
            }
            newItem.cart_checked = true
            if (data._buyNum) {
                newItem.cart_num = data._buyNum
            } else {
                newItem.cart_num = data.minBuyCount
            }
            cartList = [
                [{...newItem }]
            ]
        }
        state.cartList = cartList
        console.log('cartList', JSON.stringify(cartList))
        console.dir(cartList)
    },




    //2.删除某个商品
    deleteCartList(state, { id, storeId }) {
        console.log(111)
        console.log(id)
        console.log(storeId)
        let cartList = JSON.parse(JSON.stringify(state.cartList))
        let currentStoreIndex
        if (cartList && cartList.length) {
            cartList.forEach((item, index) => {
                if (item[0].storeId == storeId) {
                    currentStoreIndex = index
                }
            })
            if (cartList[currentStoreIndex] && cartList[currentStoreIndex].length) {
                cartList[currentStoreIndex] = cartList[currentStoreIndex].filter((item2) => {
                    return item2.id != id
                })
            }

            //删除空数组
            cartList.forEach((item, index) => {
                if (!item.length) {
                    cartList.splice(index, 1)
                }
            })
            console.log(JSON.stringify(cartList))
            state.cartList = cartList
        }

    },

    //3.清空购物车
    clearCartList(state, data) {
        state.cartList = null
    },


    //4.勾选切换某一项
    changeCartListItem(state, { id, storeId, check }) {
        console.log(111)
        console.log(id)
        console.log(storeId)
        let cartList = JSON.parse(JSON.stringify(state.cartList))
        let currentStoreIndex
        cartList.forEach((item, index) => {
            if (item[0].storeId == storeId) {
                currentStoreIndex = index
            }
        })

        cartList[currentStoreIndex].forEach((item2) => {
            if (item2.id == id) {
                item2.cart_checked = check
            }
        })

        console.log(JSON.stringify(cartList))
        state.cartList = cartList
    },

    //5.切换店铺选中状态
    changeCartListStoreItem(state, { storeId, check }) {
        console.log(111)
        console.log(storeId)
        let cartList = JSON.parse(JSON.stringify(state.cartList))
        cartList.forEach((item, index) => {
            if (item[0].storeId == storeId) {
                item.forEach((item2) => {
                    item2.cart_checked = check
                })
            }
        })


        console.log(JSON.stringify(cartList))
        state.cartList = cartList
    },

    //6.切换全部商品的选中状态选中
    changeCartListAllToChecked(state, { check }) {
        let cartList = JSON.parse(JSON.stringify(state.cartList))
        cartList.forEach((item) => {
            item.forEach((item2) => {
                item2.cart_checked = check
            })
        })
        console.log(JSON.stringify(cartList))
        state.cartList = cartList
    },

    //7.修改购物车商品数量
    changeCartListItemNum(state, { storeId, id, num, stockCount }) {
        //data = {storeId,id:'',num:1}


        let cartList = JSON.parse(JSON.stringify(state.cartList))
        cartList.forEach((item) => {
            if (item[0].storeId == storeId) {
                item.forEach((item2) => {
                    if (item2.id == id) {
                        if (num > stockCount) {
                            alert('库存不足3')
                            return
                        }
                        item2.cart_num = num
                    }
                })
            }
        })
        console.log(JSON.stringify(cartList))
        state.cartList = cartList
    },
    //6.切换全部商品的选中状态选中
    changeCartListAllToCheckedFalse(state) {

        let cartList = JSON.parse(JSON.stringify(state.cartList))
        if (cartList && cartList.length) {
            cartList.forEach((item) => {
                item.forEach((item2) => {
                    item2.cart_checked = false
                })
            })
            console.log(JSON.stringify(cartList))
            state.cartList = cartList
        }
    },








}


const actions = {
    // checkLogin(context){
    //   console.log(context)
    //   if(!context.state.userInfo){
    //     alert("未登录")
    //   }else{
    //     let url = checkLoginUrl
    //     let data ={access_token:context.state.userInfo.access_token}
    //     let param = new URLSearchParams();
    //     for (var k in data) {
    //       param.append(k, data[k]);
    //     }
    //     console.log(this)
    //     return  axios({
    //       method: "post",
    //       data: param,
    //       url
    //     }).then((res)=>{
    //       if(res.data.resultCode==1){
    //           return Promise.resolve()
    //       }else{

    //       }
    //     }).catch((err)=>{
    //       alert(JSON.stringify(err))
    //     })
    //   }

    // }
}

export default new Vuex.Store({
    state,
    actions,
    mutations,
    plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/store/index.js